import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PpbSharedModule } from 'projects/ppb-shared-library/src/lib/ppb-shared.module';
import { PseiNgCustomModule } from 'projects/ppb-shared-library/src/lib/psei-ng-custom.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { PpbShareModule } from '../shared/ppb-share.module';
import { AccountActivationService } from './account-activation.service';
import { PpbAccountActivationComponent } from './account-activation/ppb-account-activation.component';


@NgModule({
  declarations: [PpbAccountActivationComponent],
  imports: [
    CommonModule,
    SharedModule,
    PseiNgCustomModule,
    RouterModule,
    ReactiveFormsModule,
    PpbSharedModule,
    PpbShareModule
  ],
  providers: [AccountActivationService]
})
export class PpbAccountActivationModule {}
